@if (countries) {
  <div [formGroup]="form" style="margin: 0; padding: 0px; max-width: 600px">
    @if (lastError) {
      <tg-error-block [error]="lastError" [closebtn]="true"></tg-error-block>
    }
    <mat-form-field style="width: 200px; font-size: 16px">
      <input
        type="text"
        matInput
        placeholder="Timezone"
        formControlName="timeZone"
        [matAutocomplete]="autoGroup"
        />
      <mat-autocomplete #autoGroup="matAutocomplete">
        <mat-option value="">-- None --</mat-option>
        @for (group of countries$ | async; track group) {
          <mat-optgroup [label]="group.id + ' - ' + group.name">
            @for (zone of group.timezones; track zone) {
              <mat-option [value]="zone">
                {{ zone }}
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-autocomplete>
    </mat-form-field>
    <div i18n="Timezone settings|text @@timezoneSettings.nowTimeLabel">Сейчас: {{dateTimeNow}}</div>
    <div class="actions">
      <button
        aria-label="save timezone"
        mat-raised-button
        [disabled]="form.pristine || form.invalid"
        color="primary"
        (click)="save()"
        i18n="Timezone settings|button @@timezoneSettings.saveButton"
        >
      Сохранить
    </button>
    </div>
  </div>
} @else {
  <tg-inline-loader></tg-inline-loader>
}
